import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '26257470350562748';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export const trackPixelEvent = (eventName: string, data: any = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    try {
      window.fbq('track', eventName, data);
    } catch (e) {
      // silent fail
    }
  }
};
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.fbq) return;
    // Manually build the fbq stub without relying on an existing <script> tag in DOM
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    window.fbq = n;
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    // Inject the FB events script safely
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const target = document.head || document.body || document.documentElement;
    if (target) {
      target.appendChild(script);
    }
    try {
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
    } catch (e) {
      // silent fail
    }
  }, []);
  return <noscript data-id="element-105">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-106" />
    </noscript>;
}